<script setup>
import { ref, onMounted, computed } from 'vue'
import { retrieve_child } from '@/services/child';
import { useRoute } from 'vue-router';
import DownloadReport from './component/download_report.vue';
import loadingCard from '@/components/loading.vue';
import childCard from './component/child_card.vue'
import subsciptionCard from './component/subscriptionCard.vue'
import optionCard from './component/optionsCard.vue'
import rewardCard from './component/rewardCard.vue'
import userCard from './component/userCard.vue'

import { useStore } from 'vuex';
import { get_packages, get_characteristics } from '@/services/option';
import PackageRow from './component/packageRow.vue';
import { swalError } from '@/helper';
const route = useRoute();
const store = useStore();

const loading = ref(true)
const child = ref({})

const reports = computed(()=>store.state.statistic.reports)
const reportOption = ref([])

onMounted(async()=>{
  let response = await retrieve_child(route.params.id)
  let localReports = []
  // update api
  let package_response = await get_packages()
  reportOption.value = await parsePackage(package_response.result)
  localReports = reportOption.value.map( packageObj => {
    return {
      name: null,
      document: null,
      upload_input: false,
      showSummary: false,
      package_config: packageObj
    }
  })

  if (response.error){
    return swalError(response.result.error)
  }
  child.value = response.result.data.child.data
  const tempReports = response.result.data.child.included.filter(item => item.type == 'report').map(report => ({
    id: report.id,
    name: report.attributes.name,
    document: report.attributes.document,
    report_type: report.attributes.report_type,
    stats: JSON.parse(report.attributes.stats),
    sample_id: report.attributes.sample_id,
    attributes: report.attributes
  }));
  
  // merge uploaded report with template
  localReports.forEach((report, i) => {
    tempReports.forEach(tempReport=>{
      if (report.package_config.id == tempReport.report_type){
        // bind data with template
        report['id'] = tempReport.id
        report.document = tempReport.document
        report.name = tempReport.name
        report['sample_id'] = tempReport.sample_id
        report['attributes'] = tempReport.attributes
      }
    })
    
    // bind data with vuex
    if (report.stats != null){
      store.dispatch('statistic/restorePackage', report)
    }
  });
  store.dispatch('statistic/updateReports', localReports)
  loading.value = false
})

async function parsePackage(packages){
  const updatedPackages = await Promise.all(packages.map(async (item) => {
    const response = await get_characteristics(item.id)
    let parsedChar = parserCharacteristic(response.result)
    item['characters'] = parsedChar
    return item
  }))
  return updatedPackages
}

function parserCharacteristic(responseData){
  const parsedData = responseData.data.map(item => {
    const name = item.attributes.name;
    const id = item.id;
    const traits = [];
  
    // Find the related option_meta data for the current item
    const optionMetaData = item.relationships.traits.data.map(trait => {
      const traitDetails = responseData.included.find(includedItem => includedItem.id === trait.id);
      if (traitDetails) {
        let temp = {}
        temp['name'] = traitDetails.attributes.name
        temp['id'] = traitDetails.id
        traits.push(temp)
      }
      return traitDetails;
    });
  
    return { id, name, traits };
  });
  return parsedData
}
</script>
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Child Report"/>
    <div v-if="loading" class="row">
      <loadingCard />
    </div>
    <div v-else class="row">
      <div class="row">
        <div class="col-md-6">
          <!-- Info -->
          <childCard :child="child"/>
          <subsciptionCard :child_id="child.id"/>
          <optionCard :child_id="child.id"/>
          <rewardCard :child_id="child.id"/>
        </div>

        <!-- Report -->
        <div class="col-md-6">
          <userCard :child="child" />
          <DownloadReport v-model:reports="reports"/>
        </div>
      </div>

      <div class="row mb-5 shit" v-auto-animate>
        <template v-for="report in reports">
          <div class="mb-2">
            <PackageRow 
              v-if="report.name !== undefined" 
              :report="report" 
            /> 
          </div>
        </template>
      </div>
    </div>
  </div>
</template>